import React, { useState } from 'react';
import styled from 'styled-components';
import { HiArrowDown } from 'react-icons/hi';
import { NavComponent } from '../navigationComponents/NavComponent';
import oldtimerLogo from '../pictures/OldTimerAILogo.jpeg';
import pdfEN from '../requestForm/NFTFormularENG.pdf'
import pdfDE from '../requestForm/NFTFormularDE.pdf'
import { FaFilePdf } from "react-icons/fa6";

const StyledMain = styled.main`
  height: "100%", // Full viewport height
  minHeight: "100vh", // Ensure it covers the full content height
  width: "100vw", // Full viewport width
  maxWidth: "100vw", // Prevents overflow
  display: flex;
  flex-direction: column;
  align-items: center;
background: #eddcd3;
background: radial-gradient(circle, rgba(237, 220, 211, 1) 0%, rgba(228, 247, 247, 1) 100%);
`; 

const StyledHeader = styled.h1`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 20px;
`;

const StyledSubHeader = styled.h3`
  text-align: center;
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 20px;
`;

const StyledDiv = styled.div`
  display: flex;
  width: fit-content;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  margin: auto;
  padding: 20px;
  border-radius: 15px;

  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2), 0 4px 6px rgba(0, 0, 0, 0.1); /* 3D shadow effect */
  transform: translateY(-5px); /* Slight lift */
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-10px); /* Lift more on hover */
    box-shadow: 0 15px 20px rgba(0, 0, 0, 0.3), 0 6px 8px rgba(0, 0, 0, 0.2); /* Stronger shadow on hover */
  }
`;

const StyledDivText = styled.div`
  display: flex;
  flex-direction: column; /* Stack content vertically */
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #ffffff; /* White background for contrast */
  margin: 20px auto;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05); /* Subtle shadow */
  border: 1px solid #ddd; /* Light border for a clean look */
  max-width: 800px; /* Limit width for better readability */
  line-height: 1.8; /* Improve text readability */
  font-family: 'Arial', sans-serif; /* Clean, professional font */
  color: #333; /* Dark grey text for readability */

  p {
    margin-bottom: 20px; /* Add spacing between paragraphs */
    text-align: left;
  }

  ul {
    margin-left: 20px; /* Indent lists */
    padding-left: 20px;
    list-style-type: disc; /* Use bullet points for lists */
  }

  li {
    margin-bottom: 10px; /* Add spacing between list items */
  }

  a {
    color: #b86fec; /* Match link color with the theme */
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s ease;

    &:hover {
      color: #9a5ecb; /* Darker purple on hover */
    }
  }

  strong {
    font-weight: bold; /* Highlight important text */
  }

  em {
    font-style: italic; /* Italicize emphasized text */
  }
`;

const StyledButton = styled.button`
  background-color: #b86fec;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #9a5ecb;
  }
`;

const StyledLink = styled.a`
  color: #b86fec;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease;

  &:hover {
    color: #9a5ecb;
  }
`;

function ProjectOldtimerNFT() {
  const [openRequestText, setOpenRequestText] = useState(false);

  const toggle_RequestText = () => {
    setOpenRequestText(!openRequestText);
  };

  return (
    <StyledMain>
      <NavComponent />
      <br />
      <StyledHeader>The Oldtimer NFT Collection is Launched on OpenSea!</StyledHeader>
      
      <br />
      <StyledDiv>
        <img src={oldtimerLogo} alt="Oldtimer NFT Logo" height={200} width={200} />
      </StyledDiv>
      <br />
      <StyledSubHeader>
        You can visit the Oldtimer NFT Collection here:
      </StyledSubHeader>
      <StyledLink href="https://opensea.io/collection/oldtimernftcollection" target="_blank" rel="noopener noreferrer">
        OpenSea Collection
      </StyledLink>
      <br />
      <br />
      <StyledHeader>
        Want Your Oldtimer to Become Part of the Collection?{' '}
        <StyledButton onClick={toggle_RequestText}>
          <HiArrowDown />
        </StyledButton>
      </StyledHeader>
      {openRequestText && (
        <StyledDivText>
          <h3 style={{ textAlign: 'center' }}><strong>
            Submit your request to add your Oldtimer to the collection. Our team will review your submission and get back to you shortly.
            </strong></h3>
          <br />
                    <div>
                    <div>
                        <text>Want to give your oldtimer the new</text>
                        <text style={{fontWeight: "bold"}}> high-tech flair</text>
                        <text>?</text>
                    </div> 
                    <br/>
                    <div>
                        <text>Turn it into</text>
                        <text style={{fontWeight: "bold"}}>  digital art</text>
                        <text>!</text>
                    </div>
                    <br/> 
                    <br/>
                    <div>
                        <text>Let it become forever stored on the blockchain, for only</text>
                        <text style={{fontWeight: "bold"}}> 250€</text>
                        <text>!</text>
                    </div>
                    <br/>
                    <br/>
                    <p style={{textAlign: "left"}}>
                    Apply for an Oltimer NFT, by replying to this email with the necessary information - Note: only the first 80 applications will be accepted.
                    Send us a picture of your car in the attachment, and the data which shall be stored among on the blockchain. Make it public!</p>
                    
                    <br/>
                    <p style={{textAlign: "left"}}><text style={{fontWeight: "bold"}}>Your application - MUST HAVE's:</text>
                    <ul style={{textAlign: "left"}}>
                        <li><text>Description:</text> <text style={{fontStyle: "italic", fontSize: "smaller"}}>- e.g. The perfect oldtimer one could imagine! Perfect shape, kept beloved as family treasure!</text></li>
                        <li><text>Brand:</text> - <text style={{fontStyle: "italic", fontSize: "smaller"}}>e.g. Porsche</text></li>
                        <li><text>Model:</text> - <text style={{fontStyle: "italic", fontSize: "smaller"}}>e.g. 928</text></li>
                        <li><text>Year:</text> - <text style={{fontStyle: "italic", fontSize: "smaller"}}>e.g. 1980</text></li>
                        <li>VIN: -</li>
                    </ul>
                    </p>
                    <p style={{textAlign: "left"}}><text style={{fontWeight: "bold"}}>Your application - optional's:</text>
                        <ul>
                            <li>Owner: -</li>
                            <li>History: -</li>
                            <li>Condition: -</li>
                            <li>Mileage: -</li>
                            <li>Power: -</li>
                            <li>Equipment: -</li>
                        </ul>
                    </p>

                    <p>The NFT will become part of CryptoBartl's Oldtimer Collection: <a href='https://opensea.io/collection/oldtimernftcollection'> https://opensea.io/collection/oldtimernftcollection</a>.</p> 
                    <p>If you would like to get your own personal collection, please let us know and send us the name of your collection - will cost additional 100€. </p>
                    <p>
                        <text style={{fontWeight: "bold"}}>Make sure you send us your crypto wallet address among with the application! </text> <br/>
                        <text>If you do not have a crypto wallet address and would like us to create one for you, this is also do-able, but will cost additional 250€ (side note: it's easier if you create this on your own, by following the steps: https://support.metamask.io/start/getting-started-with-metamask/ , but we can of course also take this over.)
                        After creating the NFT, this will be sent to the mentioned crypto wallet address.</text>
                    </p>
                    <br/>
                    <br/>
                    <p style={{textAlign: "center"}}>
                        <text style={{textAlign: "center"}}>Procedure:</text><br/>
                        <br/>
                        <text style={{textAlign: "center"}}>You apply for the NFT by replying to this email with the completed request form --&gt; We will review your request and, if you qualify, we will create the NFT and send it to you! --&gt; After that, we will generate and send you the receipt --&gt; You make the payment.
                        </text>
                    </p>
                    <br/>
                    <p> 
                        <br/>
                        <text style={{fontStyle: "italic", fontSize: "small"}}>Please note that no additional support will be granted.</text> <br/>
                        <text style={{fontStyle: "italic", fontSize: "small"}}>By starting an order, you agree with the Terms and Conditions and Privacy Policy of CryptoBartl.com (<a href='https://cryptobartl.com/Legals'>https://cryptobartl.com/Legals</a>)
                        </text>
                        <br/>
                    </p>
                    </div>
        </StyledDivText>
      )}
      <br />
      <br />
      <br />

      <h3 style={{textAlign: "center"}}>Send an email with the filled-in request over email to emb@cryptobartl.com and we will check your application.</h3>
                <br/>
                <br />
                <br />
                <br />

                <a
                    href={pdfEN}
                    target='_blank'
                    rel='noopener noreferrer'
                    >
                    <button 
                    style={{
                        fontWeight: "bold",
                        border: "2px solid black",
                        cursor: "pointer",
                        backgroundColor: "#FF0000",
                        color: "white",
                        padding: "15px 20px",
                        borderRadius: "10px",
                        textAlign: "center",
                        fontSize: "16px",
                        transition: "transform 0.2s ease, background-color 0.3s ease",
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = "#CC0000"} // Darker red on hover
                    onMouseLeave={(e) => e.target.style.backgroundColor = "#FF0000"} // Reset color on mouse leave
                    >
                    Click here to Open <br /><br />
                    <FaFilePdf style={{ fontSize: "24px", marginBottom: "10px" }} /> {/* PDF Icon */}
                    <br />
                    the NFT Request Form <br />
                    <span style={{ color: "black", fontSize: "14px" }}>(English version)</span>
                    </button>
                </a>___
                <a
                    href={pdfDE}
                    target='_blank'
                    rel='noopener noreferrer'
                    >
                    <button 
                    style={{
                        fontWeight: "bold",
                        border: "2px solid black",
                        cursor: "pointer",
                        backgroundColor: "#FF0000",
                        color: "white",
                        padding: "15px 20px",
                        borderRadius: "10px",
                        textAlign: "center",
                        fontSize: "16px",
                        transition: "transform 0.2s ease, background-color 0.3s ease",
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = "#CC0000"} // Darker red on hover
                    onMouseLeave={(e) => e.target.style.backgroundColor = "#FF0000"} // Reset color on mouse leave
                    >
                    Click here to Open <br /><br />
                    <FaFilePdf style={{ fontSize: "24px", marginBottom: "10px" }} /> {/* PDF Icon */}
                    <br />
                    the NFT Request Form <br />
                    <span style={{ color: "black", fontSize: "14px" }}>(German version)</span>
                    </button>
                </a>

                <br/>
                <br/>
    </StyledMain>
  );
}

export default ProjectOldtimerNFT;